(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ld-gold-by-mail"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-gold-page]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const copy = JSON.parse(root.querySelector('[data-gold-copy]').textContent);
  const get = selector => root.querySelector(selector);
  const photoInput=root.querySelector('#gold-photos'),photoSelection=root.querySelector('[data-photo-selection]');
  if(photoInput&&photoSelection)photoInput.addEventListener('change',()=>{const names=[...photoInput.files].map(file=>file.name);photoSelection.textContent=names.length?copy.photoSelected+' ('+names.length+'): '+names.join(', '):'';});

  const money = value => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(value);
  const karats = ['24ct','22ct','21.6ct','21ct','20ct','18ct','15ct','14ct','10ct','9ct','8ct'];
  let method = 'post', feed = null, failed = false, sequence = 0;
  function usable() { return feed && !failed && !feed.stale && Date.now() - Date.parse(feed.fetchedAt) < 15 * 60 * 1000; }
  function activeRows() { return !usable() ? [] : method === 'post' ? (feed.postal && feed.postal.ok && !feed.postal.stale ? feed.postal.rows : []) : feed.rows || []; }
  function calculate() {
    let grossCents = 0, complete = true;
    const summary = [];
    root.querySelectorAll('.ld-mail__item').forEach(row => {
      const karat = row.querySelector('select').value;
      const weight = Number(row.querySelector('input').value);
      const rate = activeRows().find(r => r.karat === karat);
      if (!rate || !(rate.perGram > 0) || !(weight > 0) || weight > 10000) { complete = false; return; }
      grossCents += Math.round(rate.perGram * weight * 100);
      summary.push(karat + ': ' + weight + 'g at ' + money(rate.perGram) + '/g');
    });
    const gross = grossCents / 100;
    get('[data-gross]').textContent = complete ? money(gross) : '—';
    get('[data-net]').textContent = complete ? money(gross) : '—';
    get('[data-estimate-note]').textContent = method === 'post' ? copy.postNote : copy.storeNote;
    const field = get('[data-form-estimate]');
    if (field) field.value = complete ? (method === 'post' ? 'POSTAL' : 'IN-STORE') + ' INDICATIVE ESTIMATE ONLY: ' + summary.join('; ') + '. Gross gold value ' + money(gross) + ', estimated payout ' + money(gross) + '. Not a locked offer.' : copy.enter;
  }
  function table(target, rates) {
    target.replaceChildren();
    karats.forEach(karat => {
      const row = document.createElement('tr'), label = document.createElement('td'), price = document.createElement('td');
      label.textContent = karat;
      const rate = (rates || []).find(r => r.karat === karat);
      price.textContent = rate && rate.perGram > 0 ? money(rate.perGram) : '—';
      row.append(label, price); target.append(row);
    });
  }
  function refreshMarket() {
    const marketOkay = usable() && feed.metals;
    [['gold','[data-market-gold]'],['silver','[data-market-silver]'],['platinum','[data-market-platinum]']].forEach(([name, selector]) => {
      const metal = marketOkay && feed.metals[name];
      const value = metal && metal.ok && !metal.stale && Number(metal.spotPerOz) > 0 ? money(Number(metal.spotPerOz)) : '—';
      root.querySelectorAll(selector).forEach(node => { node.textContent = value; });
    });
    const stamp = marketOkay ? new Date(feed.fetchedAt).toLocaleString('en-AU', { timeZone: 'Australia/Melbourne', day:'numeric', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' }) : '';
    root.querySelectorAll('[data-market-updated]').forEach(node => { node.textContent = stamp ? copy.marketUpdated + ' ' + stamp + ' (Melbourne)' : copy.marketUnavailable; });
  }
  function refreshDisplay() {
    refreshMarket();
    table(get('[data-store-rows]'), usable() ? feed.rows : []);
    table(get('[data-post-rows]'), usable() && feed.postal && !feed.postal.stale ? feed.postal.rows : []);
    get('[data-rate-status]').textContent = !usable() ? copy.unavailable : method === 'post' && (!feed.postal || !feed.postal.configured) ? copy.unset : method === 'post' && !feed.postal.ok ? copy.unavailable : copy.updated + ' ' + new Date(feed.fetchedAt).toLocaleString('en-AU', { timeZone: 'Australia/Melbourne', day:'numeric',month:'short',hour:'2-digit',minute:'2-digit' }) + ' (Melbourne)';
    calculate();
  }
  function selectMethod(next) {
    method = next;
    root.querySelectorAll('[data-method]').forEach(button => { const active = button.dataset.method === method; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
    get('[data-rates-store]').hidden = method !== 'store'; get('[data-rates-post]').hidden = method !== 'post';
    const cta = get('[data-estimate-cta]'); cta.href = method === 'post' ? '#gold-post-enquiry' : '#gold-visit'; cta.textContent = method === 'post' ? copy.request : copy.visit;
    refreshDisplay();
  }
  function addItem() {
    if (root.querySelectorAll('.ld-mail__item').length >= 10) return;
    const id = ++sequence, row = document.createElement('div'); row.className = 'ld-mail__item';
    const purity = document.createElement('div'), weight = document.createElement('div');
    const pl = document.createElement('label'); pl.htmlFor = 'gold-purity-' + id; pl.textContent = copy.purity;
    const select = document.createElement('select'); select.id = pl.htmlFor;
    select.add(new Option(copy.choose, '')); karats.forEach(karat => select.add(new Option(karat, karat)));
    const wl = document.createElement('label'); wl.htmlFor = 'gold-weight-' + id; wl.textContent = copy.weight;
    const input = document.createElement('input'); input.type = 'number'; input.id = wl.htmlFor; input.min = '0.01'; input.max = '10000'; input.step = '0.01'; input.inputMode = 'decimal'; input.placeholder = '0.00';
    const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'ld-mail__remove'; remove.textContent = '×'; remove.setAttribute('aria-label', copy.remove);
    remove.addEventListener('click', () => { row.remove(); if (!root.querySelector('.ld-mail__item')) addItem(); get('[data-add-item]').disabled = false; calculate(); get('[data-add-item]').focus(); });
    select.addEventListener('change', calculate); input.addEventListener('input', calculate);
    purity.append(pl,select); weight.append(wl,input); row.append(purity,weight,remove); get('[data-estimate-items]').append(row);
    get('[data-add-item]').disabled = root.querySelectorAll('.ld-mail__item').length >= 10;
    calculate();
  }
  root.querySelectorAll('[data-method]').forEach(button => button.addEventListener('click', () => selectMethod(button.dataset.method)));
  root.querySelectorAll('a[href="#gold-post"]').forEach(link => link.addEventListener('click', () => selectMethod('post')));
  get('[data-add-item]').addEventListener('click', addItem);
  const form = get('#gp-request');
  if (form) form.addEventListener('submit', () => { selectMethod('post'); });
  if (location.protocol !== 'file:' && !document.querySelector('[data-gold-postal-client]')) { const script=document.createElement('script');script.src='https://sell.lostdesigner.com.au/gold-postal/client.js';script.dataset.goldPostalClient='true';script.defer=true;document.head.append(script); }
  async function loadRates() {
    try {
      const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 10000);
      let response;
      try { response = await fetch(root.dataset.endpoint, { cache: 'no-store', signal: controller.signal }); } finally { clearTimeout(timer); }
      if (!response.ok) throw new Error('Rates unavailable');
      feed = await response.json(); failed = !feed.ok;
      try { const postalResponse=await fetch('https://sell.lostdesigner.com.au/api/gold-postal-price',{cache:'no-store',signal:AbortSignal.timeout(10000)});feed.postal=await postalResponse.json(); } catch (_) { feed.postal={ok:false,configured:false,stale:true,rows:[]}; }
    } catch (_) { failed = true; }
    refreshDisplay();
  }
  addItem(); selectMethod('post'); loadRates();
  setInterval(() => { if (!document.hidden) loadRates(); }, 60000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) loadRates(); });
  const success = get('.ld-mail__success'); if (success) { success.focus(); success.scrollIntoView({ block:'center' }); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-gold-postal"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-gold-page]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const copy = JSON.parse(root.querySelector('[data-gold-copy]').textContent);
  const get = selector => root.querySelector(selector);
  const photoInput=root.querySelector('#gold-photos'),photoSelection=root.querySelector('[data-photo-selection]');
  if(photoInput&&photoSelection)photoInput.addEventListener('change',()=>{const names=[...photoInput.files].map(file=>file.name);photoSelection.textContent=names.length?copy.photoSelected+' ('+names.length+'): '+names.join(', '):'';});

  const money = value => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(value);
  const karats = ['24ct','22ct','21.6ct','21ct','20ct','18ct','15ct','14ct','10ct','9ct','8ct'];
  let method = 'store', feed = null, failed = false, sequence = 0;
  function usable() { return feed && !failed && !feed.stale && Date.now() - Date.parse(feed.fetchedAt) < 15 * 60 * 1000; }
  function activeRows() { return !usable() ? [] : method === 'post' ? (feed.postal && feed.postal.ok && !feed.postal.stale ? feed.postal.rows : []) : feed.rows || []; }
  function calculate() {
    let grossCents = 0, complete = true;
    const summary = [];
    root.querySelectorAll('.ld-gold__item').forEach(row => {
      const karat = row.querySelector('select').value;
      const weight = Number(row.querySelector('input').value);
      const rate = activeRows().find(r => r.karat === karat);
      if (!rate || !(rate.perGram > 0) || !(weight > 0) || weight > 10000) { complete = false; return; }
      grossCents += Math.round(rate.perGram * weight * 100);
      summary.push(karat + ': ' + weight + 'g at ' + money(rate.perGram) + '/g');
    });
    const gross = grossCents / 100;
    get('[data-gross]').textContent = complete ? money(gross) : '—';
    get('[data-net]').textContent = complete ? money(gross) : '—';
    get('[data-estimate-note]').textContent = method === 'post' ? copy.postNote : copy.storeNote;
    const field = get('[data-form-estimate]');
    if (field) field.value = complete ? (method === 'post' ? 'POSTAL' : 'IN-STORE') + ' INDICATIVE ESTIMATE ONLY: ' + summary.join('; ') + '. Gross gold value ' + money(gross) + ', estimated payout ' + money(gross) + '. Not a locked offer.' : copy.enter;
  }
  function table(target, rates) {
    target.replaceChildren();
    karats.forEach(karat => {
      const row = document.createElement('tr'), label = document.createElement('td'), price = document.createElement('td');
      label.textContent = karat;
      const rate = (rates || []).find(r => r.karat === karat);
      price.textContent = rate && rate.perGram > 0 ? money(rate.perGram) : '—';
      row.append(label, price); target.append(row);
    });
  }
  function refreshMarket() {
    const marketOkay = usable() && feed.metals;
    [['gold','[data-market-gold]'],['silver','[data-market-silver]'],['platinum','[data-market-platinum]']].forEach(([name, selector]) => {
      const metal = marketOkay && feed.metals[name];
      const value = metal && metal.ok && !metal.stale && Number(metal.spotPerOz) > 0 ? money(Number(metal.spotPerOz)) : '—';
      root.querySelectorAll(selector).forEach(node => { node.textContent = value; });
    });
    const stamp = marketOkay ? new Date(feed.fetchedAt).toLocaleString('en-AU', { timeZone: 'Australia/Melbourne', day:'numeric', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' }) : '';
    root.querySelectorAll('[data-market-updated]').forEach(node => { node.textContent = stamp ? copy.marketUpdated + ' ' + stamp + ' (Melbourne)' : copy.marketUnavailable; });
  }
  function refreshDisplay() {
    refreshMarket();
    table(get('[data-store-rows]'), usable() ? feed.rows : []);
    table(get('[data-post-rows]'), usable() && feed.postal && !feed.postal.stale ? feed.postal.rows : []);
    get('[data-rate-status]').textContent = !usable() ? copy.unavailable : method === 'post' && (!feed.postal || !feed.postal.configured) ? copy.unset : method === 'post' && !feed.postal.ok ? copy.unavailable : copy.updated + ' ' + new Date(feed.fetchedAt).toLocaleString('en-AU', { timeZone: 'Australia/Melbourne', day:'numeric',month:'short',hour:'2-digit',minute:'2-digit' }) + ' (Melbourne)';
    calculate();
  }
  function selectMethod(next) {
    method = next;
    root.querySelectorAll('[data-method]').forEach(button => { const active = button.dataset.method === method; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
    get('[data-rates-store]').hidden = method !== 'store'; get('[data-rates-post]').hidden = method !== 'post';
    const cta = get('[data-estimate-cta]'); cta.href = method === 'post' ? '#gold-post-enquiry' : '#gold-visit'; cta.textContent = method === 'post' ? copy.request : copy.visit;
    refreshDisplay();
  }
  function addItem() {
    if (root.querySelectorAll('.ld-gold__item').length >= 10) return;
    const id = ++sequence, row = document.createElement('div'); row.className = 'ld-gold__item';
    const purity = document.createElement('div'), weight = document.createElement('div');
    const pl = document.createElement('label'); pl.htmlFor = 'gold-purity-' + id; pl.textContent = copy.purity;
    const select = document.createElement('select'); select.id = pl.htmlFor;
    select.add(new Option(copy.choose, '')); karats.forEach(karat => select.add(new Option(karat, karat)));
    const wl = document.createElement('label'); wl.htmlFor = 'gold-weight-' + id; wl.textContent = copy.weight;
    const input = document.createElement('input'); input.type = 'number'; input.id = wl.htmlFor; input.min = '0.01'; input.max = '10000'; input.step = '0.01'; input.inputMode = 'decimal'; input.placeholder = '0.00';
    const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'ld-gold__remove'; remove.textContent = '×'; remove.setAttribute('aria-label', copy.remove);
    remove.addEventListener('click', () => { row.remove(); if (!root.querySelector('.ld-gold__item')) addItem(); get('[data-add-item]').disabled = false; calculate(); get('[data-add-item]').focus(); });
    select.addEventListener('change', calculate); input.addEventListener('input', calculate);
    purity.append(pl,select); weight.append(wl,input); row.append(purity,weight,remove); get('[data-estimate-items]').append(row);
    get('[data-add-item]').disabled = root.querySelectorAll('.ld-gold__item').length >= 10;
    calculate();
  }
  root.querySelectorAll('[data-method]').forEach(button => button.addEventListener('click', () => selectMethod(button.dataset.method)));
  root.querySelectorAll('a[href="#gold-post"]').forEach(link => link.addEventListener('click', () => selectMethod('post')));
  get('[data-add-item]').addEventListener('click', addItem);
  const form = get('#gp-request');
  if (form) form.addEventListener('submit', () => { selectMethod('post'); });
  if (location.protocol !== 'file:' && !document.querySelector('[data-gold-postal-client]')) { const script=document.createElement('script');script.src='https://sell.lostdesigner.com.au/gold-postal/client.js';script.dataset.goldPostalClient='true';script.defer=true;document.head.append(script); }
  async function loadRates() {
    try {
      const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 10000);
      let response;
      try { response = await fetch(root.dataset.endpoint, { cache: 'no-store', signal: controller.signal }); } finally { clearTimeout(timer); }
      if (!response.ok) throw new Error('Rates unavailable');
      feed = await response.json(); failed = !feed.ok;
      try { const postalResponse=await fetch('https://sell.lostdesigner.com.au/api/gold-postal-price',{cache:'no-store',signal:AbortSignal.timeout(10000)});feed.postal=await postalResponse.json(); } catch (_) { feed.postal={ok:false,configured:false,stale:true,rows:[]}; }
    } catch (_) { failed = true; }
    refreshDisplay();
  }
  addItem(); loadRates();
  setInterval(() => { if (!document.hidden) loadRates(); }, 60000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) loadRates(); });
  const success = get('.ld-gold__success'); if (success) { success.focus(); success.scrollIntoView({ block:'center' }); }
})();

  } catch(e) { console.error(e); }
})();
})();
